import { Injectable } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class CopyService {
  constructor(
    private _clipboardService: ClipboardService,
    private toastrService: ToastrService
  ) {}

  // 引数で渡された文字列をクリップボードにコピー
  copyToClipboard(text: string): void {
    this._clipboardService.copyFromContent(text);
    this.toastrService.info('コピーが完了しました。');
  }

  // 選択範囲の文字列を返却
  selectedText(): string {
    let text = '';
    if (window.getSelection) {
      text = window.getSelection().toString();
    }
    return text;
  }
}
